import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

import './desktop-app-download-style.scss';
import AppDownloadBanner from '@src/imagesNew/banner/maccaron-app-recommend.png';

import Typography from '@src/componentsNew/Typography/Typography';

import { handleDeepLink } from '@src/utils/deepLink';

interface IProps {
  deepLink: string;
  infoText: string;
}

const DesktopAppDownload = ({ deepLink, infoText }: IProps) => {
  const handleQRCodeScan = () => {
    handleDeepLink(deepLink);
  };

  return (
    <div id="desktop-app-download-wrapper">
      <div className="text-wrapper">
        <Typography cName="app-text" variant="h7" component="h4" style={{ color: '#212121' }}>
          {infoText}
        </Typography>

        <div className="qr-code-wrapper">
          <Typography variant="subtitle2" component="p" style={{ color: '#666666' }}>
            Scan to download App!
          </Typography>

          <QRCodeCanvas value={deepLink} onClick={handleQRCodeScan} />
        </div>
      </div>

      <img className="app-download-banner" src={AppDownloadBanner} alt="maccaron-app" />
    </div>
  );
};

export default DesktopAppDownload;
